<template>
  <div class="col-lg-10 col-md-12 mx-auto">
    <h5>Crea nuovo abbonamento</h5>
    <div class="pt-2 col- mx-auto">
      <b-form @submit.prevent="onSubmit">
        <p class="text-left font-weight-bold">nome:</p>
        <b-form-input class="my-2" id="nome" v-model="form.nome" type="text" required></b-form-input>
        <p class="text-left font-weight-bold">tipo professionista:</p>
        <b-form-select v-model="form.tipo_professionista" class="mb-3">
          <b-form-select-option v-for="role in roleOptions" :key="role" :value="role">{{role}}</b-form-select-option>
        </b-form-select>
        <b-button block variant="primary" type="submit" class="my-2">Crea nuova categoria</b-button>
      </b-form>
      <p v-if="msg">{{msg}}</p>
      <div class="pt-2 col- mx-auto" v-if="categorie">
        <p v-for="(categoria,ind) in categorie" :key="ind">
          <strong class="text-secondary">nome :</strong>
          {{categoria.nome}}
          <strong class="text-secondary">tipo professionista:</strong>
          {{categoria.ruolo.nome}}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NuovaCategoria",
  data() {
    return {
      form: {
        tipo_professionista: null,
        nome: null
      },
      roleOptions: null,
      msg: null,
      categorie: null
    };
  },
  methods: {
    fetchData() {
      var url = process.env.VUE_APP_VERSION + "ruolo/all";
      this.$axios
        .get(url)
        .then(res => {
          console.log(res.data.data);
          this.roleOptions = res.data.data;
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    fetchCategories() {
      var url = process.env.VUE_APP_VERSION + "categoria/all";
      this.$axios
        .get(url)
        .then(res => {
          console.log(res.data.data);
          this.categorie = res.data.data;
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    onSubmit() {
      var url = process.env.VUE_APP_VERSION + "categoria";
      this.$axios
        .post(url, this.form)
        .then(res => {
          console.log(res.data.data);
          this.msg = "nuova categoria creata";
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    }
  },
  created() {
    this.fetchData();
    this.fetchCategories();
  }
};
</script>